import React from 'react'
import { useSelector } from 'react-redux'

import Field from '../../../../../../components/Form/Field'
import DatesFields from './DatesFields'
import BudgetFields from './BudgetFields'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'
import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'

import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { googleCampaignsTypeList } from '../../../../../../constants/selectLists/campaigns'
import { END_DATE, START_DATE } from '../../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import { CAMPAIGN_TYPE } from '../fields'

const NewCampaignBudgetFields = ({ formik, remainingBudget }) => {
  const { currency_symbol: currencySymbol } = useSelector(selectedGoogleAdAccountSelector)

  const { values } = formik

  const startDate = values[START_DATE]
  const endDate = values[END_DATE]

  const showBudgetSection = startDate && endDate

  if (remainingBudget < 1) {
    return <ErrorMessage fontSize={14} error="Your total remaining budget is too low to create a campaign." />
  }

  return (
    <>
      <FieldLabelWrapper label="Campaign type">
        <Field
          placeholder="Campaign type"
          formik={formik}
          name={CAMPAIGN_TYPE}
          options={googleCampaignsTypeList}
          isSearchable={false}
        />
      </FieldLabelWrapper>
      <DatesFields formik={formik} />
      {
        // Show budget fields only when user selected dateStart and dateStop, because budget daily is based on dateRange
        showBudgetSection && (
          <BudgetFields
            currencySymbol={currencySymbol}
            formik={formik}
            remainingBudget={remainingBudget}
            startDate={startDate}
            endDate={endDate}
          />
        )
      }
    </>
  )
}

export default NewCampaignBudgetFields
